/* DARYA · מגירת עגלה
   סדר הפעולות: קודם מוודאים שהעגלה מעודכנת, אחר כך מושכים את המגירה
   עם מניעת קאשינג, ורק אז פותחים — כך היא לא נפתחת ריקה. */
window.daryaCart=(function(){
  function sectionWrap(){return document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]')}

  function paint(n){
    document.querySelectorAll('.dhd-count').forEach(function(el){el.textContent=n});
    var a=document.querySelector('.dhd-cart');
    if(!a)return;
    var badge=a.querySelector('.dhd-count');
    if(n>0&&!badge){
      var s=document.createElement('span');s.className='dhd-count';s.textContent=n;a.appendChild(s);
    }else if(n===0&&badge){
      badge.remove();
    }
  }

  function updateCount(){
    return fetch('/cart.js',{cache:'no-store'})
      .then(function(r){return r.json()})
      .then(function(c){paint(c.item_count);return c})
      .catch(function(){return null});
  }

  function refresh(){
    var wrap=sectionWrap();
    if(!wrap)return Promise.resolve(null);
    var sid=wrap.id.replace('shopify-section-','');
    var path=window.location.pathname||'/';
    var url=path+'?sections='+encodeURIComponent(sid)+'&_dc='+Date.now();
    return fetch(url,{cache:'no-store',headers:{'Cache-Control':'no-cache','Pragma':'no-cache'}})
      .then(function(r){return r.json()})
      .then(function(j){
        var html=j&&j[sid];
        if(html){
          var t=document.createElement('div');t.innerHTML=html;
          var nw=t.querySelector('#cart-drawer');
          var old=document.getElementById('cart-drawer');
          if(nw&&old){old.replaceWith(nw)}
        }
        return document.getElementById('cart-drawer');
      })
      .catch(function(){return null});
  }

  function show(){
    var dr=document.getElementById('cart-drawer');
    if(!dr)return false;
    if(typeof dr.show==='function'){dr.show();return true}
    if('open' in dr){dr.open=true;return true}
    return false;
  }

  function open(){
    if(!sectionWrap()){window.location='/cart';return Promise.resolve()}
    return updateCount()
      .then(function(){return refresh()})
      .then(function(){
        if(!show()){window.location='/cart'}
      })
      .catch(function(){window.location='/cart'});
  }

  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('.dhd-cart');
    if(a&&sectionWrap()){e.preventDefault();open()}
  });

  document.addEventListener('darya:cart:changed',function(){updateCount()});

  return{open:open,updateCount:updateCount,refresh:refresh};
})();
